import { FormControlLabel, Stack, Switch } from '@mui/material';
import { useSnackbar } from 'notistack';
import { type ChangeEvent, useState } from 'react';

import { AccordionWithHeading, ContentLoading } from '../../../components/general';
import { trpc } from '../../../trpc.ts';
import { type TerminProps } from '../../../utils';
import { content } from './ThemaAusschreibungsprozessCard.content.ts';

export const ThemaAusschreibungsprozessCard = ({ thema }: TerminProps) => {
  const [manuellerAusschreibungsprozess, setManuellerAusschreibungsprozess] = useState(
    thema.manuellerAusschreibungsprozess,
  );

  const { enqueueSnackbar } = useSnackbar();

  const ausschreibungsprozessMutation = trpc.thema.updateAusschreibungsprozess.useMutation({
    onSuccess: () => {
      enqueueSnackbar(manuellerAusschreibungsprozess ? content.manualSuccess : content.automaticSuccess, {
        variant: 'success',
      });
    },
    onError: () => {
      enqueueSnackbar(content.changeError, {
        variant: 'error',
        persist: true,
      });
    },
  });

  if (!thema.planungsinformation) {
    return (
      <AccordionWithHeading heading={content.ausschreibungsprozess}>
        <ContentLoading />
      </AccordionWithHeading>
    );
  }

  const handleChange = async (event: ChangeEvent<HTMLInputElement>) => {
    setManuellerAusschreibungsprozess(event.target.checked);
    await ausschreibungsprozessMutation.mutateAsync({
      akaThemaId: thema.akaThemaId,
      manuellerAusschreibungsprozess: event.target.checked,
    });
  };

  return (
    <AccordionWithHeading heading={content.ausschreibungsprozess} noAccordion>
      <Stack direction="row" justifyContent="space-between">
        <FormControlLabel
          sx={(theme) => ({
            '& .MuiFormControlLabel-label.Mui-disabled': {
              opacity: 1,
              color: theme.palette.text.primary,
            },
            '& .MuiFormControlLabel-label': {
              fontSize: '14px',
            },
            marginLeft: 0,
          })}
          control={<Switch checked={manuellerAusschreibungsprozess} onChange={(evt) => void handleChange(evt)} />}
          label={content.manuellerAusschreibungsprozess}
        />
      </Stack>
    </AccordionWithHeading>
  );
};
